import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { Table } from '../../../components';
import { Content, PageContainer, TitleContainer, TitleRightSide, Input } from './ChatterInfluencersPage.styles';
import { Text24Bold } from '../../../components/utils/Text/Text.styles';
import debounce from 'lodash.debounce';
import { useSearchParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { selectFetchInfluencersInfo } from '../../../store/slices/chatter/slice';
import { fetchInfluencerInfo } from '../../../store/slices/chatter/asyncThunks';
import ChatterInfluencerItem from '../../../components/Table/items/ChatterInfluencerItem/ChatterInfluencerItem';
import { selectUser } from '../../../store/slices/user/slice';
import { CRM_ORGANIZATION_MEMBER_ROLE } from '../../../utils/constants';

const ChatterInfluencersPage = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const page = +searchParams.get('page') || 1;
  const search = searchParams.get('search') || '';
  const perPage = +searchParams.get('perPage') || 25;
  const [searchValue, setSearchValue] = useState(() => search ?? '');
  const { data, total, pending } = useSelector(selectFetchInfluencersInfo);
  const user = useSelector(selectUser);
  const dispatch = useDispatch();

  useEffect(() => {
    if (page > 0) {
      dispatch(fetchInfluencerInfo({ page, search: search, perPage }));
    }
  }, [dispatch, page, search, perPage]);

  const setPage = useCallback(
    page => {
      const params = new URLSearchParams(searchParams);
      params.set('page', page);
      setSearchParams(params);
    },
    [searchParams, setSearchParams],
  );
  const setPerPage = useCallback(
    value => {
      const params = new URLSearchParams(searchParams);
      params.set('perPage', value);
      params.set('page', 1);
      setSearchParams(params);
    },
    [searchParams, setSearchParams],
  );

  const changeHandler = useCallback(
    text => {
      const params = new URLSearchParams(searchParams);
      params.set('search', text);
      params.set('page', 1);
      setSearchParams(params);
    },
    [searchParams, setSearchParams],
  );

  const debouncedChangeHandler = useMemo(() => debounce(changeHandler, 300), [changeHandler]);

  const tableHeader =
    user.role === CRM_ORGANIZATION_MEMBER_ROLE.CHATTER
      ? [{ label: 'Name' }, { label: 'Unread status' }, { type: 'action' }]
      : [{ label: 'Name' }, { type: 'action' }];

  return (
    <PageContainer>
      <TitleContainer>
        <Text24Bold>Creators</Text24Bold>
        <TitleRightSide>
          <Input
            hideErrorMessage
            placeholder="Search"
            value={searchValue}
            onChange={event => {
              setSearchValue(event.target.value);
              debouncedChangeHandler(event.target.value);
            }}
          />
        </TitleRightSide>
      </TitleContainer>
      <Content>
        <Table
          headerInformation={tableHeader}
          dataLoading={pending}
          totalCount={total}
          currentPage={page}
          perPage={perPage}
          setPerPage={setPerPage}
          setPage={setPage}
          emptyDataText={'No data'}
          showPerPage
          fullHeight>
          {data.map(item => (
            <ChatterInfluencerItem
              key={item._id}
              id={item._id}
              name={item.name}
              profilePhoto={item.profilePhoto}
              unreadCount={item.unreadCount}
              {...(user.role === CRM_ORGANIZATION_MEMBER_ROLE.CHATTER && { unreadCount: item.unreadCount })}
            />
          ))}
        </Table>
      </Content>
    </PageContainer>
  );
};

export default ChatterInfluencersPage;
